import React from 'react';

const QuickInfo = (props) => {
    const { country, climate, currency, primaryLanguage, touristVisaRequired } = props;

    return (
        <div>
            <h2>Quick Information</h2>
            <p>
                <b>Country: </b>
                <span>{country}</span>
            </p>
            <p>
                <b>Climate: </b>
                <span>{capitalizeFirstLetter(climate)}</span>
            </p>
            <p>
                <b>Currency: </b>
                <span>{currency}</span>
            </p>
            <p>
                <b>Primary Language: </b>
                <span>{primaryLanguage}</span>
            </p>
            <p>
                <b>Tourist Visa: </b>
                <span>{`${touristVisaRequired ? '' : 'Not'} requried`}</span>
            </p>
        </div>
    )
};

export default QuickInfo;

const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
